import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["common", "user", "accessor", "admin", "approver"],
};

export default persistConfig;
